// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React, { useEffect, useState } from 'react'
import { func, string } from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Field } from 'redux-form'
import { UpdatedMultiSelect } from 'components/Form'
import { getThemUsers } from './helpers'

const UserNameMultiSelect = ({ getThemUsers, idRoot }) => {
  const [options, setOptions] = useState([])

  useEffect(() => {
    const getAndSetUsers = async () => {
      const newOptions = await getThemUsers()
      setOptions(newOptions)
    }
    getAndSetUsers()
  }, [])

  return (
    <Field
      component={UpdatedMultiSelect}
      className={'username'}
      label={'Username'}
      labelKey={'userName'}
      id={`${idRoot}create-user`}
      isClearable={false}
      isMulti={false}
      name={'createUserId'}
      options={options}
      valueKey={'userId'} />
  )
}

UserNameMultiSelect.propTypes = {
  idRoot: string.isRequired,
  getThemUsers: func.isRequired,
}

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    getThemUsers,
  }, dispatch)
)

export default connect(
  null,
  mapDispatchToProps,
)(UserNameMultiSelect)
